/**
 * Converts Contentful's "GridContainer" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import ContentBlock from '../ContentBlock'

const ContentfulGridContainer = ({
  id, direction, container, spacing, justify, xs, sm, md, lg, contentBlocks,
}) => (
  <Grid
    direction={direction}
    spacing={spacing}
    justify={justify}
    container>
    {contentBlocks.map((content) => (
      <Grid
        key={`${id}-${content.id}`}
        className={cx('py-md')}
        xs={xs}
        sm={sm}
        md={md}
        lg={lg}
        container={container}
        item>
        <ContentBlock content={{
          ...content,
          className: cx(content.className, 'flex-1'),
        }} />
      </Grid>
    ))}
  </Grid>
)

ContentfulGridContainer.propTypes = {
  container: false,
  justify: 'flex-start',
}

ContentfulGridContainer.propTypes = {
  id: PropTypes.string,
  direction: PropTypes.oneOf(['row', 'column']),
  spacing: PropTypes.number,
  justify: PropTypes.string,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  container: PropTypes.bool,
  contentBlocks: PropTypes.array,
}

export default ContentfulGridContainer
